import { Context } from "../urlCategories";
import { urls } from "./urlsConfig";
export var getUrls = function getUrls(_ref) {
  var siteId = _ref.siteId,
      stage = _ref.stage,
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? Context.MAIN : _ref$context;
  return urls[siteId][stage][context];
};